import React from 'react';
import { Pie } from 'react-chartjs-2';
import PropTypes from 'prop-types';
import styles from './PieChart.module.scss';

class PieChart extends React.Component {
    // If used as callback to send data to <PieChart /> , canvas argument is usable, its used for creating gradients for fill amongst other things //
    getChartData = () => {
        const { data } = this.props;

        const defaultChartData = {
            datasets: [
                {
                    fill: false,
                    lineTension: 0.1,
                    borderColor: '#fff',
                    borderCapStyle: 'butt',
                    borderDash: [],
                    borderDashOffset: 0.0,
                    borderJoinStyle: 'miter',
                    pointBorderColor: '#fff',
                    pointBackgroundColor: '#fff',
                    pointBorderWidth: 1,
                    pointHoverRadius: 5,
                    pointHoverBackgroundColor: '#fff',
                    pointHoverBorderColor: 'rgba(220,220,220,1)',
                    pointHoverBorderWidth: 2,
                    pointRadius: 1,
                    pointHitRadius: 10
                }
            ]
        };

        const chartData = { ...defaultChartData, ...data };

        return chartData;
    };

    render() {
        // Options are passed as props if needed, options include yAxis and xAxis labels, responsivness, toolpit data and style etc... //
        const { options, legend, getElementAtEvent, getDatasetAtEvent } = this.props;

        return (
            <div className={`${styles['pie-chart']}`}>
                <Pie
                    data={this.getChartData}
                    options={options}
                    legend={legend}
                    getElementAtEvent={getElementAtEvent}
                    getDatasetAtEvent={getDatasetAtEvent}
                />
            </div>
        );
    }
}

PieChart.defaultProps = {
    data: {},
    options: {},
    legend: {},
    getElementAtEvent: () => {},
    getDatasetAtEvent: () => {}
};

PieChart.propTypes = {
    data: PropTypes.oneOfType([PropTypes.object]),
    options: PropTypes.oneOfType([PropTypes.object]),
    legend: PropTypes.oneOfType([PropTypes.object]),
    getElementAtEvent: PropTypes.func,
    getDatasetAtEvent: PropTypes.func
};

export default PieChart;
